(() => {
  if (window.__luaWeddingSortInstalled) return;
  window.__luaWeddingSortInstalled = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-lcw-sort-form]')) return;
    const select = form.querySelector('select[name="sort_by"]');
    if (!select || !select.value) return;

    event.preventDefault();
    const next = new URL(window.location.href);
    next.searchParams.set('sort_by', select.value);
    next.searchParams.delete('page');
    next.hash = 'WeddingCatalog';
    window.location.assign(next.href);
  });
})();
